import IconButton from '@/shared/components/IconButton/IconButton'
import Slider from '@/shared/components/Slider/Slider'
import { useFloorPlanStore } from '../../store/useFloorPlanStore'
import { ZOOM_MAX, ZOOM_MIN, ZOOM_STEP } from '../../utils/defaults'
import styles from './FloorPlanZoomBar.module.scss'

function FloorPlanZoomBar() {
  const zoom = useFloorPlanStore(s => s.zoom)
  const setZoom = useFloorPlanStore(s => s.setZoom)
  const fitToTables = useFloorPlanStore(s => s.fitToTables)

  return (
    <div className={styles.zoomBar} id="tour-floor-plan-zoom">
      <IconButton
        icon="las la-crosshairs icon-big"
        color="primary"
        onClick={fitToTables}
      />
      <IconButton
        icon="las la-search-minus icon-big"
        color="primary"
        onClick={() => setZoom(zoom - ZOOM_STEP)}
        disabled={zoom <= ZOOM_MIN}
      />
      <div className={styles.slider}>
        <Slider
          zoom={zoom}
          min={ZOOM_MIN}
          max={ZOOM_MAX}
          step={ZOOM_STEP}
          onZoom={value => setZoom(value)}
        />
      </div>
      <IconButton
        icon="las la-search-plus icon-big"
        color="primary"
        onClick={() => setZoom(zoom + ZOOM_STEP)}
        disabled={zoom >= ZOOM_MAX}
      />
      <span className={styles.zoomValue}>{Math.round(zoom * 100)}%</span>
    </div>
  )
}

export default FloorPlanZoomBar
